import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-md border border-border bg-input text-[hsl(var(--card-foreground))] dark:text-white px-3 py-2 text-base focus-visible:border-ring dark:focus-visible:border-ring  ring-offset-background  file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[var(--inativo-text)] dark:placeholder:text-inativo-text focus-visible:outline-none focus-visible:transparent  disabled:cursor-not-allowed disabled:bg-[var(--input-disabled)] disabled:border-0 disabled:!text-inativo md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
